var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_174_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.937 12.1368V14.3761C15.9379 14.584 15.8952 14.7897 15.8118 14.9802C15.7283 15.1707 15.6059 15.3417 15.4525 15.4822C15.299 15.6227 15.1178 15.7297 14.9204 15.7963C14.7231 15.8629 14.514 15.8877 14.3066 15.8689C12.0051 15.6194 9.79445 14.8345 7.85212 13.5774C6.04504 12.4314 4.51295 10.9023 3.36466 9.09883C2.10067 7.15155 1.31407 4.9345 1.06857 2.62729C1.04988 2.42088 1.07446 2.21284 1.14074 2.01643C1.20703 1.82002 1.31356 1.63953 1.45357 1.48646C1.59357 1.33339 1.76398 1.21109 1.95394 1.12735C2.1439 1.04361 2.34925 1.00027 2.55691 1.00007H4.80065C5.16361 0.996507 5.51549 1.12478 5.7907 1.361C6.06591 1.59721 6.24567 1.92523 6.29647 2.28393C6.39117 3.00055 6.5668 3.70418 6.82001 4.3814C6.92063 4.64856 6.94241 4.93892 6.88276 5.21805C6.82311 5.49719 6.68453 5.75342 6.48345 5.95636L5.5336 6.90433C6.59829 8.77305 8.14864 10.3203 10.0211 11.3829L10.9709 10.4349C11.1743 10.2342 11.431 10.0959 11.7107 10.0364C11.9904 9.97688 12.2813 9.99862 12.549 10.099C13.2276 10.3517 13.9326 10.527 14.6506 10.6215C15.0139 10.6727 15.3457 10.8553 15.5829 11.1347C15.8201 11.4141 15.9461 11.7707 15.937 12.1368Z",
    stroke: "#99A1B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_174_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/Mobile.bc4771fa239998828f02d8de943d47db.svg";
export { ForwardRef as ReactComponent };